import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:92
* @route '/api'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/api',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:92
* @route '/api'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:92
* @route '/api'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:92
* @route '/api'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:92
* @route '/api'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:92
* @route '/api'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::index
* @see app/Http/Controllers/PublicController.php:92
* @route '/api'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\PublicController::send
* @see app/Http/Controllers/PublicController.php:97
* @route '/api/envoi-message'
*/
export const send = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: send.url(options),
    method: 'get',
})

send.definition = {
    methods: ["get","head"],
    url: '/api/envoi-message',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::send
* @see app/Http/Controllers/PublicController.php:97
* @route '/api/envoi-message'
*/
send.url = (options?: RouteQueryOptions) => {
    return send.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::send
* @see app/Http/Controllers/PublicController.php:97
* @route '/api/envoi-message'
*/
send.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: send.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::send
* @see app/Http/Controllers/PublicController.php:97
* @route '/api/envoi-message'
*/
send.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: send.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::send
* @see app/Http/Controllers/PublicController.php:97
* @route '/api/envoi-message'
*/
const sendForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: send.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::send
* @see app/Http/Controllers/PublicController.php:97
* @route '/api/envoi-message'
*/
sendForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: send.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::send
* @see app/Http/Controllers/PublicController.php:97
* @route '/api/envoi-message'
*/
sendForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: send.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

send.form = sendForm

/**
* @see \App\Http\Controllers\PublicController::verify
* @see app/Http/Controllers/PublicController.php:102
* @route '/api/validation-numero'
*/
export const verify = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: verify.url(options),
    method: 'get',
})

verify.definition = {
    methods: ["get","head"],
    url: '/api/validation-numero',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::verify
* @see app/Http/Controllers/PublicController.php:102
* @route '/api/validation-numero'
*/
verify.url = (options?: RouteQueryOptions) => {
    return verify.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::verify
* @see app/Http/Controllers/PublicController.php:102
* @route '/api/validation-numero'
*/
verify.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: verify.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::verify
* @see app/Http/Controllers/PublicController.php:102
* @route '/api/validation-numero'
*/
verify.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: verify.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::verify
* @see app/Http/Controllers/PublicController.php:102
* @route '/api/validation-numero'
*/
const verifyForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: verify.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::verify
* @see app/Http/Controllers/PublicController.php:102
* @route '/api/validation-numero'
*/
verifyForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: verify.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::verify
* @see app/Http/Controllers/PublicController.php:102
* @route '/api/validation-numero'
*/
verifyForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: verify.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

verify.form = verifyForm

/**
* @see \App\Http\Controllers\PublicController::auth
* @see app/Http/Controllers/PublicController.php:107
* @route '/api/authentification'
*/
export const auth = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: auth.url(options),
    method: 'get',
})

auth.definition = {
    methods: ["get","head"],
    url: '/api/authentification',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::auth
* @see app/Http/Controllers/PublicController.php:107
* @route '/api/authentification'
*/
auth.url = (options?: RouteQueryOptions) => {
    return auth.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::auth
* @see app/Http/Controllers/PublicController.php:107
* @route '/api/authentification'
*/
auth.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: auth.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::auth
* @see app/Http/Controllers/PublicController.php:107
* @route '/api/authentification'
*/
auth.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: auth.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::auth
* @see app/Http/Controllers/PublicController.php:107
* @route '/api/authentification'
*/
const authForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: auth.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::auth
* @see app/Http/Controllers/PublicController.php:107
* @route '/api/authentification'
*/
authForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: auth.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::auth
* @see app/Http/Controllers/PublicController.php:107
* @route '/api/authentification'
*/
authForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: auth.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

auth.form = authForm

/**
* @see \App\Http\Controllers\PublicController::examples
* @see app/Http/Controllers/PublicController.php:112
* @route '/api/exemples'
*/
export const examples = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: examples.url(options),
    method: 'get',
})

examples.definition = {
    methods: ["get","head"],
    url: '/api/exemples',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::examples
* @see app/Http/Controllers/PublicController.php:112
* @route '/api/exemples'
*/
examples.url = (options?: RouteQueryOptions) => {
    return examples.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::examples
* @see app/Http/Controllers/PublicController.php:112
* @route '/api/exemples'
*/
examples.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: examples.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::examples
* @see app/Http/Controllers/PublicController.php:112
* @route '/api/exemples'
*/
examples.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: examples.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::examples
* @see app/Http/Controllers/PublicController.php:112
* @route '/api/exemples'
*/
const examplesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: examples.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::examples
* @see app/Http/Controllers/PublicController.php:112
* @route '/api/exemples'
*/
examplesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: examples.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::examples
* @see app/Http/Controllers/PublicController.php:112
* @route '/api/exemples'
*/
examplesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: examples.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

examples.form = examplesForm

/**
* @see \App\Http\Controllers\PublicController::errors
* @see app/Http/Controllers/PublicController.php:117
* @route '/api/codes-erreur'
*/
export const errors = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: errors.url(options),
    method: 'get',
})

errors.definition = {
    methods: ["get","head"],
    url: '/api/codes-erreur',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::errors
* @see app/Http/Controllers/PublicController.php:117
* @route '/api/codes-erreur'
*/
errors.url = (options?: RouteQueryOptions) => {
    return errors.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::errors
* @see app/Http/Controllers/PublicController.php:117
* @route '/api/codes-erreur'
*/
errors.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: errors.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::errors
* @see app/Http/Controllers/PublicController.php:117
* @route '/api/codes-erreur'
*/
errors.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: errors.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::errors
* @see app/Http/Controllers/PublicController.php:117
* @route '/api/codes-erreur'
*/
const errorsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: errors.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::errors
* @see app/Http/Controllers/PublicController.php:117
* @route '/api/codes-erreur'
*/
errorsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: errors.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::errors
* @see app/Http/Controllers/PublicController.php:117
* @route '/api/codes-erreur'
*/
errorsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: errors.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

errors.form = errorsForm

/**
* @see \App\Http\Controllers\PublicController::sandbox
* @see app/Http/Controllers/PublicController.php:122
* @route '/api/sandbox'
*/
export const sandbox = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sandbox.url(options),
    method: 'get',
})

sandbox.definition = {
    methods: ["get","head"],
    url: '/api/sandbox',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::sandbox
* @see app/Http/Controllers/PublicController.php:122
* @route '/api/sandbox'
*/
sandbox.url = (options?: RouteQueryOptions) => {
    return sandbox.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::sandbox
* @see app/Http/Controllers/PublicController.php:122
* @route '/api/sandbox'
*/
sandbox.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sandbox.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::sandbox
* @see app/Http/Controllers/PublicController.php:122
* @route '/api/sandbox'
*/
sandbox.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: sandbox.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::sandbox
* @see app/Http/Controllers/PublicController.php:122
* @route '/api/sandbox'
*/
const sandboxForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sandbox.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::sandbox
* @see app/Http/Controllers/PublicController.php:122
* @route '/api/sandbox'
*/
sandboxForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sandbox.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::sandbox
* @see app/Http/Controllers/PublicController.php:122
* @route '/api/sandbox'
*/
sandboxForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sandbox.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

sandbox.form = sandboxForm

const api = {
    index: Object.assign(index, index),
    send: Object.assign(send, send),
    verify: Object.assign(verify, verify),
    auth: Object.assign(auth, auth),
    examples: Object.assign(examples, examples),
    errors: Object.assign(errors, errors),
    sandbox: Object.assign(sandbox, sandbox),
}

export default api